module.exports = __webpack_public_path__ + "static/triangle-e92d1eca2acb3f9e3299dd9a97fd6593.png";